import React from 'react'
import AgeGateContent from './AgeGateContent'

export default function AgeGatePage () {
  return (
    <div className='ageGatePage web'>
      <AgeGateContent />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/age-gate/AgeGatePage.jsx